module.exports = __webpack_public_path__ + "img/donation-1-mobile.d3487f4a.png";